import { Component, OnInit, ViewChild } from "@angular/core";
import { TemplatesService } from "../templates.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { RoutingConstants } from "../../constants/routingConstants";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { CommonService } from "src/app/core/services/common.service";
import { RichTextEditorComponent } from "src/app/shared/rich-text-editor/rich-text-editor.component";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { ConvertToPDFService } from "src/app/core/services/convertToPDF.service";
import { Template } from "src/app/models/templates.model";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-create-edit-templates",
  templateUrl: "./create-edit-templates.component.html",
  styleUrls: ["./create-edit-templates.component.scss"],
})
export class CreateEditTemplatesComponent implements OnInit {
  @ViewChild(RichTextEditorComponent) editor: RichTextEditorComponent;
  operation: string;
  template;
  routing = RoutingConstants.templatesRouting;
  patronLanguage: string = "es";
  templateValue: string;

  constructor(
    private templateService: TemplatesService,
    private activatedRoute: ActivatedRoute,
    private toastrAlertService: ToastrAlertService,
    private router: Router,
    private sweetAlertService: SweetAlertService,
    private commonService: CommonService,
    private translateService: TranslateService,
    private convertToPDFService: ConvertToPDFService
  ) {}

  ngOnInit(): void {
    this.convertToPDFService.getImg("");

    this.initFormGroup();
    this.operation = this.activatedRoute.data["_value"]["operation"];
    if (
      this.operation === "edicion" &&
      this.activatedRoute.snapshot.params.id
    ) {
      let id = this.activatedRoute.snapshot.params.id;
      this.templateService.getTemplate(id).subscribe(
        (data) => {
          if (data != null) {
            this.setValues(data);
          }
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  initFormGroup() {
    this.template = new FormGroup({
      editorValue: new FormControl(""),
      paId: new FormControl("", [
        Validators.required,
        Validators.maxLength(32),
      ]),
      paDescr: new FormControl("", [Validators.maxLength(64)]),
      paEsParrafo: new FormControl("", [Validators.maxLength(8)]),
      patronesidiomaEsDto: new FormGroup({
        id: new FormGroup({
          piIdioma: new FormControl("es"),
          piPatron: new FormControl(""),
        }),
        piFichero: new FormControl("NotUsed"),
        piTexto: new FormControl(""),
      }),
    });
  }

  setValues(data: Template) {
    if (data.paEsParrafo == 1) {
      data.paEsParrafo = true;
    } else {
      data.paEsParrafo = false;
    }
    this.template.patchValue({
      paId: data.paId,
      paDescr: data.paDescr,
      paEsParrafo: data.paEsParrafo,
      patronesidiomaEsDto: data.patronesidiomaEsDto,
      editorValue: data.patronesidiomaEsDto.piTexto,
    });
    if (data.patronesidiomaEsDto && data.patronesidiomaEsDto?.piTexto != null) {
      this.editor.Editor.setData(
        this.template.value.patronesidiomaEsDto.piTexto
      );
    }
  }

  onCreate() {
    this.sweetAlertService.sweetAlertLoading();
    this.templateService.createTemplate(this.template.value).subscribe(
      (data) => {
        this.sweetAlertService.sweetAlertClose();
        this.toastrAlertService.toastrSuccess(
          data["mensaje"],
          this.routing.list
        );
      },
      (err) => {
        this.sweetAlertService.sweetAlertClose();
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  onUpdate() {
    this.sweetAlertService.sweetAlertLoading();
    this.templateService.updateTemplate(this.template.value).subscribe(
      (data) => {
        this.sweetAlertService.sweetAlertClose();
        this.toastrAlertService.toastrSuccess(
          data["mensaje"],
          this.routing.list
        );
      },
      (err) => {
        this.sweetAlertService.sweetAlertClose();
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  formatValues(): boolean {
    this.template.value.patronesidiomaEsDto.id.piPatron =
      this.template.value.paId;

    if (this.template.value.paEsParrafo == true) {
      this.template.patchValue({
        paEsParrafo: 1,
      });
    } else {
      this.template.patchValue({
        paEsParrafo: 0,
      });
    }

    if (this.patronLanguage == "es" && this.editor.Editor.getData() !== "") {
      this.template.value.patronesidiomaEsDto.piTexto =
        this.editor.Editor.getData();
    } else {
      const message = this.translateService.instant(
        "messages.fieldsRequired.templateRequired"
      );
      this.toastrAlertService.toastrFail(message);
      return false;
    }
    return true;
  }

  onSave() {
    let invalidFields = this.commonService.findInvalidControls(
      this.template.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else {
      if (this.formatValues()) {
        if (this.operation === "edicion") {
          this.onUpdate();
        } else if (this.operation === "creacion") {
          this.onCreate();
        }
      }
    }
  }

  goList() {
    this.router.navigate([this.routing.list]);
  }

  public previewPDF() {
    let content = this.editor.Editor.getData();
    this.convertToPDFService.previewPDF(
      content,
      this.activatedRoute.snapshot.params.id,
      "111111111111",
      "OTHER",
      "",
      "open",
      null,
      ""
    );
  }
}
